/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.sales.rpc.ViewServiceRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type CurrentUserPermissions = {
  canCommunicate: boolean;
  canEdit: boolean;
  canDelete: boolean;
  canView: Default<boolean>;
  canMerge: Default<boolean>;
};

export type Direction = 'FORWARD' | 'BACKWARD' | unhandledEnumCase;

export type FilterDateTimeFormat =
  | 'EPOCH_MILLISECONDS'
  | 'DATE'
  | 'RELATIVE_TIME_DURATION'
  | unhandledEnumCase;

export type FilterTimeUnit =
  | 'SECOND'
  | 'MINUTE'
  | 'HOUR'
  | 'DAY'
  | 'WEEK'
  | 'MONTH'
  | 'QUARTER'
  | 'YEAR'
  | unhandledEnumCase;

export type Sort = {
  property: string;
  missing?: string;
  order: Default<SortOrder>;
};

export type SortOrder = 'ASC' | 'DESC' | unhandledEnumCase;

export type TimezoneSource = 'PORTAL' | 'USER' | unhandledEnumCase;

export type ViewsRpcError = {
  errorType: ViewsRpcErrorType;
  errorMessage: string;
  statusCode?: number;
  propertyNames: Default<string[]>;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ViewsRpcErrorType =
  | 'BOARD_CONFIG_COPY_FAILED'
  | 'CRM_SEARCH_ERROR'
  | 'CROSS_OBJECT_FILTERS_NOT_SUPPORTED'
  | 'HIGHLY_SENSITIVE_PROPERTY'
  | 'IMPORT_LIST_NOT_FOUND'
  | 'INTERNAL_ERROR'
  | 'INVALID_COUNT'
  | 'INVALID_PROPERTY'
  | 'INVALID_REQUEST'
  | 'MAX_COUNT_EXCEEDED'
  | 'MISSING_PORTAL_IN_REQUEST'
  | 'MISSING_USER_IN_REQUEST'
  | 'PERMISSION_DENIED'
  | 'PERSONALIZED_VIEW_NOT_FOUND'
  | 'PROPERTY_PERMISSION_DENIED'
  | 'QUERY_TOO_LONG'
  | 'RATE_LIMITED'
  | 'SEARCH_TIMEOUT'
  | 'SORT_PROPERTY_TOO_LARGE'
  | 'VIEW_NOT_FOUND'
  | unhandledEnumCase;

export type CrmObjectSearchRequest = {
  objectTypeId: string;
  filterGroups: Default<FilterGroup[]>;
  sorts: Default<Sort[]>;
  properties?: string[];
  customQueryProperties: Default<string[]>;
  query?: string;
  timeZoneId?: string;
  timeZoneSource?: TimezoneSource;
  count: Default<number>;
  offset: Default<number>;
};

export type CrmObjectSearchResponse = {
  results: Default<CrmObjectSearchResult[]>;
  total: number;
  hasMore: boolean;
  offset: number;
};

export type CrmObjectSearchResult = {
  objectId: number;
  objectTypeId: string;
  currentUserPermissions?: CurrentUserPermissions;
  properties: Default<Record<string, SimplePropertyValue>>;
};

export type CrmObjectTableSearchRequest = {
  objectTypeId: string;
  filterGroups: Default<FilterGroup[]>;
  sortCriteria: Default<ViewSort[]>;
  customQueryProperties: Default<string[]>;
  query?: string;
  timeZoneSource?: TimezoneSource;
  count: Default<number>;
  offset: Default<number>;
};

export type CrmObjectTableSearchResponse = {
  objectIds: Default<number[]>;
  total: number;
  hasMore: boolean;
  offset: number;
  processedQueryObject?: CrmObjectTableSearchRequest;
};

export type SimplePropertyValue = {
  name: string;
  value: string;
  source?: string;
  sourceId?: string;
  timestamp: number;
};

export type CrossObjectFilter = {
  objectTypeId: string;
  operator: CrossObjectFilterOperator;
  combinedAssociationTypeId: string;
  query?: string;
  customQueryProperties: Default<string[]>;
  filterGroups: Default<FilterGroup[]>;
};

export type CrossObjectFilterOperator =
  | 'ASSOCIATED'
  | 'NOT_ASSOCIATED'
  | unhandledEnumCase;

/**
 *  Use the FilterMapper util class for mapping it to and from the CrmSearch Filter
 */
export type Filter = {
  dateTimeFormat?: FilterDateTimeFormat;
  highValue?: string | number | boolean;
  inclusive?: boolean;
  operator: FilterOperator;
  property: string;
  propertySuffix?: string;
  comparisonProperty?: string;
  direction?: Direction;
  upperBoundInclusive?: boolean;
  lowerBoundInclusive?: boolean;
  rollForward: Default<boolean>;
  rollingOffset: Default<string | number | boolean>;
  rollingOffsetUnit?: FilterTimeUnit;
  timeUnit?: FilterTimeUnit;
  timeUnitCount?: number;
  value?: string | number | boolean;
  values: Default<(string | number | boolean)[]>;
};

export type FilterGroup = {
  filters: Default<Filter[]>;
  crossObjectFilters: Default<CrossObjectFilter[]>;
};

export type FilterOperator =
  | 'EQ'
  | 'NEQ'
  | 'LT'
  | 'LTE'
  | 'GT'
  | 'GTE'
  | 'BETWEEN'
  | 'IN'
  | 'NOT_IN'
  | 'HAS_PROPERTY'
  | 'NOT_HAS_PROPERTY'
  | 'ROLLING_DATE_RANGE'
  | 'TIME_UNIT_TO_DATE'
  | 'LT_X_DAYS'
  | 'GT_X_DAYS'
  | 'BEFORE_ROLLING_DATE_POINT'
  | 'AFTER_ROLLING_DATE_POINT'
  | 'EQ_PROPERTY'
  | 'NEQ_PROPERTY'
  | 'LT_PROPERTY'
  | 'LTE_PROPERTY'
  | 'GT_PROPERTY'
  | 'GTE_PROPERTY'
  | 'CONTAINS_ALL'
  | 'DOES_NOT_CONTAIN_ALL'
  | 'IS_EXACTLY'
  | 'IS_NOT_EXACTLY'
  | unhandledEnumCase;

export type SortDirection = 'ASC' | 'DESC' | unhandledEnumCase;

export type ViewSort = {
  sortKey?: string;
  sortColumnName?: string;
  /** @deprecated Use getOrderDirection() instead. Legacy numeric encoding: -1 = ASC, 1 = DESC. Absent (0) means neither field was set and the request is invalid. */
  order: number;
  orderDirection?: SortDirection;
};

export type SearchCrmObjectIdsRequestType =
  Requestify<CrmObjectTableSearchRequest>;
export type SearchCrmObjectIdsResponseType = CrmObjectTableSearchResponse;
export type SearchCrmObjectIdsErrorType = ViewsRpcError & HubspotMetadata;
export const searchCrmObjectIdsRpc: ChirpAvroRpcDetails<
  SearchCrmObjectIdsRequestType,
  SearchCrmObjectIdsResponseType,
  SearchCrmObjectIdsErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.rpc.ViewServiceRpc',
  rpcName: 'searchCrmObjectIds',
  auth: 'app',
  fingerprint: 'yflHfy_beMCAxVV_QbHNoq8QWJB5zcuN',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type SearchCrmObjectsRequestType = Requestify<CrmObjectSearchRequest>;
export type SearchCrmObjectsResponseType = CrmObjectSearchResponse;
export type SearchCrmObjectsErrorType = ViewsRpcError & HubspotMetadata;
export const searchCrmObjectsRpc: ChirpAvroRpcDetails<
  SearchCrmObjectsRequestType,
  SearchCrmObjectsResponseType,
  SearchCrmObjectsErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.rpc.ViewServiceRpc',
  rpcName: 'searchCrmObjects',
  auth: 'app',
  fingerprint: 'QnRUnrkSBVnpOd6Y66VOUq8QWJB5zcuN',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
